import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="635" height="21" viewBox="0 0 635 21" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M631.63 19.07C446.74 8 252.18 9.57 5.87 8.35m627.27 4.53C481.02-1.38 331.9-4.76 1 13.7" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);